import React from "react";
import { Link } from "react-router-dom";
import { FaBullhorn, FaEdit, FaTrash, FaEye } from "react-icons/fa";
import moment from "moment";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

const CircularDetailPanel = ({ circular, permissions, onDelete }) => {
  if (!circular) {
    return (
      <div className="circular-detail-panel">
        <div className="circular-detail-empty">Select a circular to view details</div>
      </div>
    );
  }

  return (
    <div className="circular-detail-panel">
      <div className="circular-detail-header">
        <div className="circular-detail-heading">
          <span className="circular-detail-icon">
            <FaBullhorn />
          </span>
          <div>
            <div className="circular-detail-title">{circular.circular_topic}</div>
            <div className="circular-detail-time">
              {circular.created_at
                ? moment(circular.created_at).format("Do MMM'YY , HH : mm")
                : ""}
            </div>
          </div>
        </div>

        <div className="circular-detail-actions">
          {circular.circular_file && (
            <span
              className="circular-recipients-btn"
              role="button"
              onClick={() => window.open(circular.circular_file, "_blank")}
            >
              <FaEye /> View File
            </span>
          )}
          {permissions.includes("circular.update") && (
            <Link
              to={`/circular/update/${circular.id}`}
              className="circular-recipients-btn"
              title="Edit"
            >
              <FaEdit /> Edit
            </Link>
          )}
          {permissions.includes("circular.delete") && (
            <span
              className="circular-recipients-btn circular-delete-btn"
              title="Delete"
              role="button"
              onClick={() => {
                if (window.confirm("Are you sure you wish to delete this item?"))
                  onDelete(circular.id);
              }}
            >
              <FaTrash /> Delete
            </span>
          )}
        </div>
      </div>

      <div
        className="circular-detail-body"
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(circular.circular_desc) }}
      />
    </div>
  );
};

export default CircularDetailPanel;
